import { BenefitType } from "../enums/BenefitType";
import { UploadedDocument } from "../domain/UploadedDocument";

export type CriticalIllnessFormValues = {
    documents: UploadedDocument[],
}

export const defaultCriticalIllnessFormValues = {
    benefit: BenefitType.CRITICAL_ILLNESS,
    criticalIllness: true,
    documents: [{
        document: '',
        documentContent: '',
        documentType: ''
    }],
}